<template>
  <q-icon :name="name" :class="{ margin: margin }" v-if="material" />
  <i :class="name" v-else></i>
</template>

<script>
import Vue from 'vue';

/**
 * size: {string} 'xs', 'sm', 'md', 'lg', 'xl'
 */

export default Vue.extend({
  name: 'CIcon',
  props: {
    name: { type: String, required: true },
    margin: { type: Boolean },
    material: { type: Boolean },
    outlined: { type: Boolean },
  },
});
</script>

<style lang="scss" scoped></style>
